import { render, staticRenderFns } from "./CanceledSwitch.vue?vue&type=template&id=4fc1397a"
import script from "./CanceledSwitch.vue?vue&type=script&lang=ts"
export * from "./CanceledSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports